import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import MotivoParadaService from "service/meta/producao/MotivoParadaService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const motivoParadaService = new MotivoParadaService();

export default function MotivoParadaListagem() {

    const titulo = 'Motivos de parada';

    const defaultFilters: DataTableFilterMeta = {
        descricao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        }
    }


    return (

        <BaseListagem ordenacao="descricao,ASC" service={motivoParadaService} urlService="/motivoParada" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="motivoParada" >
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
        </BaseListagem>
    )
}